import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Real } from '../../core/models/real.model';

import * as moment from 'moment';
import 'moment-timezone';
import 'moment/locale/sl';
moment.tz.setDefault("Europe/Ljubljana");

@Component({
  selector: 'app-offer-info-modal',
  templateUrl: './offer-info-modal.component.html',
  styleUrls: ['./offer-info-modal.component.scss'],
})
export class OfferInfoModalComponent implements OnInit {

  @Input() service: any;
  @Input() real: Real;

  constructor(private router: Router, private modalCtrl: ModalController, public translateService: TranslateService) { }

  ngOnInit() {

  }

  onCancel() {
    this.modalCtrl.dismiss( null, 'cancel' );
  }

  goToPickSlot( real ) {

    let queryParamsObj = {};

    if ( 19369 == this.service.id ) {
      queryParamsObj = { from: '2023-10-16' }
    }

    if ( 19903 == this.service.id ) {
      queryParamsObj = { from: '2023-09-21' }
    }

    if ( 20656 == this.service.id ) {
      queryParamsObj = { from: '2023-09-21' }
    }

    if ( this.service.start ) {
      
      let startStr = this.service.start.substring(0, 10);
      let todayStr = moment().format('YYYY-MM-DD');
      
      if ( startStr > todayStr ) {
        queryParamsObj = { from: startStr };
      }
      
    }

    /*if ( 19494 == this.service.id || 19500 == this.service.id || 18144 == this.service.id  ) {
      queryParamsObj = { from: '2023-03-24' }
    }*/

    this.onCancel();
    this.router.navigate(['/', 'restavracija', real.provider.id, real.slug, 'rezervacija', 'izberi-termin'], { queryParams: queryParamsObj } );
  }

}
